module.exports = __webpack_public_path__ + "media/images/guideline/H_04-15a57ab138f0856a79bbfebe28dacdbf.jpg";